// extracted by mini-css-extract-plugin
module.exports = {"common-link-error":"riskSoftware__common-link-error","toolbar":"riskSoftware__toolbar","links":"riskSoftware__links","table-container":"riskSoftware__table-container"};